// bill_subsystem_v1: login page for bill subsystem
import React, { useState } from 'react';
import API from './api';

export default function BillLogin({ onLoggedIn }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    setError('');
    if (!email || !password) {
      setError('กรุณากรอก email และ password');
      return;
    }
    setLoading(true);
    try {
      const { data } = await API.post('/api/bill/auth/login', { email, password });
      localStorage.setItem('bill_token', data.token);
      localStorage.setItem('bill_user', JSON.stringify(data.user));
      if (onLoggedIn) onLoggedIn(data.user);
      else window.location.reload();
    } catch (err) {
      setError(err.response?.data?.error || 'เข้าสู่ระบบไม่สำเร็จ');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f0fdf4 0%, #ecfeff 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 16, fontFamily: 'Inter, sans-serif',
    }}>
      <div style={{
        background: 'white', borderRadius: 16, padding: 32,
        maxWidth: 400, width: '100%',
        boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>🧾</div>
          <h1 style={{ margin: 0, fontSize: 22, color: '#0f172a' }}>ระบบบิล</h1>
          <p style={{ margin: '4px 0 0', fontSize: 13, color: '#64748b' }}>
            เข้าสู่ระบบเพื่อจัดการใบแจ้งหนี้
          </p>
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={{ display: 'block', fontSize: 13, color: '#475569', marginBottom: 6 }}>
            Email
          </label>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            disabled={loading}
            autoFocus
            placeholder="you@company.com"
            style={{
              width: '100%', padding: '10px 12px', borderRadius: 8,
              border: '1px solid #e2e8f0', fontSize: 14, fontFamily: 'inherit',
              boxSizing: 'border-box',
            }}
            onKeyDown={e => { if (e.key === 'Enter') handleSubmit(); }}
          />
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={{ display: 'block', fontSize: 13, color: '#475569', marginBottom: 6 }}>
            Password
          </label>
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            disabled={loading}
            placeholder="••••••••"
            style={{
              width: '100%', padding: '10px 12px', borderRadius: 8,
              border: '1px solid #e2e8f0', fontSize: 14, fontFamily: 'inherit',
              boxSizing: 'border-box',
            }}
            onKeyDown={e => { if (e.key === 'Enter') handleSubmit(); }}
          />
        </div>

        {error && (
          <div style={{
            background: '#fef2f2', color: '#dc2626', padding: '10px 12px',
            borderRadius: 8, fontSize: 13, marginBottom: 14,
            border: '1px solid #fecaca',
          }}>
            ⚠️ {error}
          </div>
        )}

        <button
          onClick={handleSubmit}
          disabled={loading}
          style={{
            width: '100%', padding: '12px 16px', borderRadius: 8, border: 'none',
            background: loading ? '#94a3b8' : '#10b981', color: 'white',
            fontSize: 15, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer',
            fontFamily: 'inherit',
          }}
        >
          {loading ? 'กำลังเข้าสู่ระบบ...' : 'เข้าสู่ระบบ'}
        </button>

        <p style={{ textAlign: 'center', margin: '20px 0 0', fontSize: 12, color: '#94a3b8' }}>
          ติดต่อ owner ของบริษัทเพื่อสร้างบัญชี
        </p>
      </div>
    </div>
  );
}
